import { Form, Col, Row, Select, DatePicker, Tag, Space, Button, Divider } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { atualizarStatusControleAporte } from "../../../../services/lancamentoControleAporteService";
import { setModalRecebimentoLancamentoControleAporte } from "../../../../redux/slices/lancamentoControleAporte/lancamentoControleAporteSlice";
import { CheckOutlined, CloseOutlined, WarningOutlined } from "@ant-design/icons";
import { NumericFormat } from "react-number-format";
import { AtualizarStatusControleAporteModel } from "../../../../models/lancamentoControleAporte/chamadas/atualizarStatusControleAporteModel";

dayjs.locale("pt-br");

type FormProps = {
  dataPrevistaRecebimento: Date;
  idSorteio: number;
  valor: number;
};

const ConfirmarRecebimento = () => {
  //estados globais
  const lancamentoControleAporteState = useAppSelector((state) => state.lancamentoControleAporte);
  const sorteioState = useAppSelector((state) => state.sorteio);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<FormProps>();

  const [alerta, setAlerta] = useState<string | null>(null);

  const launchDate = dayjs(lancamentoControleAporteState.entity.dataLancamento);

  const filteredSorteios = sorteioState.listSorteioEmpresas.filter((a: any) => {
    const sorteioDate = dayjs(a.dataSorteio);
    return sorteioDate.isBefore(launchDate.add(1, "week")) && sorteioDate.isAfter(launchDate.subtract(1, "week"));
  });

  useEffect(() => {
    form.setFieldsValue({
      dataPrevistaRecebimento: dayjs(lancamentoControleAporteState.entity.dataLancamento),
      valor: lancamentoControleAporteState.entity.valor,
    });
    if (filteredSorteios.length === 0) {
      setAlerta("Não existe sorteio cadastrado anterior ou posterior a data do recebimento");
    } else {
      setAlerta(null);
    }
  }, [lancamentoControleAporteState.entity, filteredSorteios]);

  const submit = (values: FormProps) => {
    var recebimento = {
      idLancamentoControleAporteRecebimento: lancamentoControleAporteState.entity.idLancamentoControleAporte,
      idSorteioRecebimento: values.idSorteio,
    } as AtualizarStatusControleAporteModel;

    dispatch(atualizarStatusControleAporte({ value: recebimento, busca: lancamentoControleAporteState.busca }));
  };

  const voltar = () => {
    dispatch(setModalRecebimentoLancamentoControleAporte(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      {alerta !== null && (
        <Row gutter={12} style={{ marginBottom: "24px" }}>
          <Col span={24}>
            <Tag icon={<WarningOutlined />} color="warning">
              {alerta}
            </Tag>
          </Col>
        </Row>
      )}
      <Row gutter={12}>
        <Col span={8}>
          <Form.Item
            label="Data do recebimento"
            name="dataPrevistaRecebimento"
            rules={[
              {
                required: true,
                message: "Digite uma data",
              },
            ]}
          >
            <DatePicker format="DD/MM/YYYY" allowClear={false} style={{ width: "100%" }} disabled />
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item
            label="Data do sorteio recebido"
            name="idSorteio"
            rules={[
              {
                required: true,
                message: "Selecione uma data de sorteio",
              },
            ]}
          >
            <Select
              showSearch
              loading={sorteioState.loading}
              optionLabelProp="label"
              style={{ width: "100%" }}
              options={filteredSorteios.map((a: any) => ({
                value: a.idSorteio,
                label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            label="Valor"
            name="valor"
            rules={[
              {
                required: true,
                message: "Digite um valor",
              },
            ]}
          >
            <NumericFormat
              style={{ width: "100%" }}
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              disabled
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary" disabled={filteredSorteios.length === 0}>
              SALVAR
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default ConfirmarRecebimento;
